module.exports = __webpack_public_path__ + "media/promo/velle/images/top_products/prod_1-87260d4f2f1079257cd4cab95029b845.png";